module.exports = __webpack_public_path__ + "media/images/emblems/Wangen-coat_of_arms-b53d4fbf1a49b86543b89fbda4f544a7.svg";